/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvestownMetaDataDto
 */
export interface InvestownMetaDataDto {
    /**
     * 
     * @type {string}
     * @memberof InvestownMetaDataDto
     */
    projectUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestownMetaDataDto
     */
    projectType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InvestownMetaDataDto
     */
    closed?: boolean;
}

export function InvestownMetaDataDtoFromJSON(json: any): InvestownMetaDataDto {
    return InvestownMetaDataDtoFromJSONTyped(json, false);
}

export function InvestownMetaDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestownMetaDataDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'projectUrl': !exists(json, 'projectUrl') ? undefined : json['projectUrl'],
        'projectType': !exists(json, 'projectType') ? undefined : json['projectType'],
        'closed': !exists(json, 'closed') ? undefined : json['closed'],
    };
}

export function InvestownMetaDataDtoToJSON(value?: InvestownMetaDataDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'projectUrl': value.projectUrl,
        'projectType': value.projectType,
        'closed': value.closed,
    };
}

